import styled from "styled-components";

export const StyledInputList = styled.ul`
  list-style: none;
  margin: 10px 0;
  display: grid;
  gap: 10px;
`;
